import React, { SetStateAction, useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ThemeContext } from '../../App'
import { ILiquidityNet } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { colors } from '../../const'
import { useChartData } from '../../hooks/useChartData'

async function getLiquidityNetConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_liquidity_net', timeframe)) as ILiquidityNet[]
	const pools = ['BTC.BTC', 'ETH.ETH', 'BSC.BNB', 'LTC.LTC', 'BCH.BCH', 'AVAX.AVAX', 'DOGE.DOGE', 'STABLECOIN', 'BASE.ETH', 'XRP.XRP', 'TRON.TRX', 'ZEC.ZEC', 'Others']
	const assetData: ILiquidityNet[][] = []
	const seriesData: { x: number; y: number }[][] = []
	const config: IChart[] = []

	pools.forEach((pool) => {
		assetData.push(chartData.filter((row) => row.POOL_NAME === pool))
	})
	assetData.forEach((asset) => {
		seriesData.push(
			asset.map((element: ILiquidityNet) => {
				return { x: new Date(element.DAY).getTime() / 1000, y: element.NET_LIQUIDITY_CHANGE_USD }
			})
		)
	})
	const btcData = chartData.filter((row) => row.POOL_NAME === 'BTC.BTC')
	const series10 = btcData.map((element: ILiquidityNet) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_NET_LIQUIDITY_CHANGE_USD }
	})
	config.push({
		data: series10,
		strokeWidth: 2,
		name: 'TOTAL',
		type: 'line',
		seriesGroup: ' [usd]',
		color: `${color}`,
		unitSymbol: '$'
	})
	let i = 0
	seriesData.forEach((series) => {
		config.push({
			data: series,
			strokeWidth: 2,
			name: pools[i].split('-')[0] === 'STABLECOIN' ? 'STABLECOINS' : pools[i].split('-')[0],
			type: 'bars',
			seriesGroup: '[usd]',
			color: colors[i],
			unitSymbol: '$',
			barGroup: 'stacked'
		})
		i++
	})

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const LiquidityNet = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getLiquidityNetConfig, '1w')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Net Liquidity Change (add - withdraw)"
			chartDesc={`Net daily change in liquidity (additions minus withdrawals) across all pools, with breakdown by asset.\n*BNB includes both BSC.BNB and BNB.BNB.\n*Stablecoins consists of all available stablecoin pools on THORChain.`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="e4664a3a-5115-4b93-8171-abf179218161"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default LiquidityNet
